import React, { memo } from "react";
import Eye from "../../assets/Eye";

function ToggleVisibility({ visible = false, onClick, className }) {
  return (
    <div
      onClick={onClick}
      className={className}
      style={{
        backgroundColor: `${visible ? "gray" : "transparent"}`,
        position: "relative",
        height: 30,
        width: 30,
        marginTop: -30,
        top: 8,
        right: 50,
        height: 30,
        width: 30,
        borderRadius: "50%",
        display: "flex",
      }}
    >
      <Eye
        fill={`${visible ? "white" : "darkgray"}`}
        style={{
          position: "relative",
          flex: 1,
          paddingLeft: 2,
          paddingRight: 2,
          height: 30,
        }}
      />
    </div>
  );
}

export default memo(ToggleVisibility);
